import { render, staticRenderFns } from "./inventory.vue?vue&type=template&id=6a59c8da&scoped=true&"
import script from "./inventory.vue?vue&type=script&lang=ts&"
export * from "./inventory.vue?vue&type=script&lang=ts&"
import style0 from "./inventory.vue?vue&type=style&index=0&id=6a59c8da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a59c8da",
  null
  
)

export default component.exports